import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo";
import LegalDocument from "@/components/legal/LegalDocument";
import DmcaContent from "@/components/legal/DmcaContent";

export const Route = createFileRoute("/dmca")({
  component: DmcaPolicy,
  head: () =>
    seoHead({
      title: "DMCA Policy | Lutely",
      description:
        "How to report copyright infringement on Lutely and how we handle takedown notices and counter-notices.",
      canonicalPath: "/dmca",
    }),
});

function DmcaPolicy() {
  return (
    <LegalDocument title="DMCA Policy">
      <DmcaContent />
    </LegalDocument>
  );
}
